import { InjectionToken } from '@angular/core';

export interface KeyValueStorage {
  set(key: string, value: string): void;
  remove(key: string): void;
  get(key: string): string | null;
  clear(): void;
}

export const KEY_VALUE_STORAGE = new InjectionToken<KeyValueStorage>('KEY_VALUE_STORAGE');
